import RemoteSearchResultsComponent from "./remote-search-results-component";
const { useState } = wp.element;

function RemoteSearch() {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResultsTerm, setSearchResultsTerm] = useState("");

  let searchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  let handleSubmit = (event) => {
    event.preventDefault();
    setSearchResultsTerm(searchTerm);
  };

  return (
    <div className="react-search-main-wrapper">
      <div className="react-search-wrapper">
        <form onSubmit={handleSubmit}>
          <input
            className="react-search-box"
            placeholder="TV Brand"
            type="text"
            onChange={searchChange}
          />
          <input className="cta-button" type="submit" value="Search" />
        </form>
      </div>
      {searchResultsTerm !== "" ? (
        <RemoteSearchResultsComponent searchTermSlug={searchResultsTerm} />
      ) : (
        ""
      )}
    </div>
  );
}
export default RemoteSearch;



// WEBPACK FOOTER //
// ./react/components/remote-search/remote-search-component.jsx